export default "__VITE_ASSET__4ff0c6b3__"